import "./CreatePost.css"
import { useContext, useState } from 'react'
import PostContext from "../contexts/PostContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faX} from '@fortawesome/free-solid-svg-icons'

function CreatePost() {
    
    // object that holds post data
    const {postData, setPostData} = useContext(PostContext);
    // boolean to track modal popup
    const {showPost, setShowPost} = useContext(PostContext)


    // boolean to track errors 
    var post_error = false;

    var result = {};
    
    /*  Function:   toggle
    Purpose:    Toggles a boolean value
    Parameters: t - the boolean value to be toggled
    Returns:    !t - the toggled value
    */
    function toggle(t) {
        return !t;
    }

    const create_post = async () => {
        return fetch(
            "https://webdev.cse.buffalo.edu/hci/api/api/deekstra" + "/posts",
            {
                method: "POST",
                headers: {
                    'Accept': "*/*",
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
                 },
                 body: JSON.stringify({
                    authorID: sessionStorage.getItem("user") ,
                    content: "event",
                    attributes: {
                        public: (postData.privacy === "true"),
                        activity: postData.activity,
                        location: postData.location,
                        startTime: postData.start,
                        endTime: postData.end,
                        date: postData.date,
                        end_date: postData.end_day,
                        participants: [],
                        tags: [],
                        blockedBy: []
}
                 })
            })
            .then(res => res.json())
            .then( 
                result => {
                    if(result){
                        console.log(result)
                        return result
                    }
                }
            
            )
            .catch(error => {
                console.error('Error:', error)
            })
    }

    // saves activity from dropdown 
    const saveActivity = (e) => {
        const option = e.target.value
        setPostData({...postData, ['activity']: option })
        console.log("acitivty: " + postData.activity)
  
    }
    // saves location from dropdown
    const saveLocation = (e) => {
        const option = e.target.value 
        setPostData({...postData, ['location']: option })
        console.log("location: " + postData.location)

    }
    // saves first date from input 
    const saveFirst = (e) => {
        const text = e.target.value
        const new_string = text.split("-")

        setPostData({...postData, ['date']: new_string[1] + "/" + new_string[2] + "/" + new_string[0] })
        console.log("first date: " + postData.date)

    }
    // saves last date to credentials 
    const saveLast = (e) => {
        const text = e.target.value
        const new_string = text.split("-")

        setPostData({...postData, ['end_day']: new_string[1] + "/" + new_string[2] + "/" + new_string[0] })
        console.log("date: " + postData.end_day)

    }
    // saves start time from dropdown
    const saveStart = (e) => {
        const text = e.target.value
        setPostData({...postData, ['start']: text })
        console.log("start time: " + postData.start)
 
    }
    // saves end time from input
    const saveEnd = (e) => {
        const text = e.target.value
        setPostData({...postData, ['end']: text })
        console.log("end time: " + postData.end)

    }
    // alters boolean if post is public or private
    const savePrivate = (e) => {
        const option = e.target.value
        
        if(option == "Public"){
            setPostData({...postData, ['privacy']: 'true' })
        }else{
            setPostData({...postData, ['privacy']: 'false' })
        }
        console.log("privacy: " + postData.privacy)

    }
/*
    const validate = () => {
        let activity_val = document.getElementById("hm-activity-dropdown").value
        let location_val = document.getElementById("hm-location-dropdown").value
        let start_date_input = document.getElementById("hm-first-date").value
        let end_date_input = document.getElementById("hm-end-date").value
        let start_time_input = document.getElementById("hm-start-time").value
        let end_time_input = document.getElementById("hm-end-time").value
        let privacy_val = document.getElementById("hm-public-dropdown").value

        if(activity_val === ""){
            document.getElementById("event-error").innerHTML = "Must Choose an Activity"
            if(!post_error) post_error=true
        }else{
            document.getElementById("event-error").innerHTML = ""
            if(post_error) post_error=false
        }

        if(location_val === ""){
            document.getElementById("location-error").innerHTML = "Must Choose a Location"
            if(!post_error) post_error=true
        }else{
            document.getElementById("location-error").innerHTML = ""
            if(post_error) post_error=false
        }

        if(start_date_input === ""){
            document.getElementById("start-date-error").innerHTML = "Must Choose a Start Date"
            if(!post_error) post_error=true
        }else{
            document.getElementById("start-date-error").innerHTML = ""
            if(post_error) post_error=false
        }

        if(end_date_input === ""){
            document.getElementById("end-date-error").innerHTML = "Must Choose an End Date"
            if(!post_error) post_error=true
        }else{
            document.getElementById("end-date-error").innerHTML = ""
            if(post_error) post_error=false
        }

        if(start_time_input === ""){
            document.getElementById("start-time-error").innerHTML = "Must Choose a Start Time"
            if(!post_error) post_error=true
        }else{
            document.getElementById("start-time-error").innerHTML = ""
            if(post_error) post_error=false
        }

        if(end_time_input === ""){
            document.getElementById("end-time-error").innerHTML = "Must Choose an End Time"
            if(!post_error) post_error=true
        }else{
            document.getElementById("end-time-error").innerHTML = ""
            if(post_error) post_error=false
        }

        if(privacy_val === ""){
            document.getElementById("privacy-error").innerHTML = "Must Choose a Privacy Option"
            if(!post_error) post_error=true
        }else{
            document.getElementById("privacy-error").innerHTML = ""
            if(post_error) post_error=false
        }

    }
*/

    const submission = async () => {
        const creation = await create_post()
        result = creation
        setShowPost(toggle(showPost))

    }

    return (
        <form onSubmit={submission}>
            {/* <div className = "postBoxContainer"> */}
                <div className = "PostBoxBG">
                    <div className = "lg-box-header">
                        <h1>Create Post</h1>
                    </div>

                    <div className = "post-form"> 
                        <div className = "rg-input-wrapper">
                            <label htmlFor="hm-activity" className="form-input-label">Activity <span style={{color:'#e63946'}}>*</span></label>
                            <select className="rg-input-text" name="hm-activity-dropdown" id="hm-activity-dropdown" onChange={saveActivity} required>
                                <option value="">Select Activity</option>
                                <option value="Studying">Studying</option>
                                <option value="Hanging Out">Hanging Out</option>
                                <option value="Exercising">Exercising</option>
                                <option value="Club/School Event">Club/School Event</option>
                                <option value="Party">Party</option>
                                <option value="Eating">Eating</option>
                            </select>
                            <label id="event-error" className="post-form-error"></label>
                        </div>

                        <div className = "rg-input-wrapper">
                            <label htmlFor="hm-location" className="form-input-label">Location <span style={{color:'#e63946'}}>*</span></label>
                            <select className="rg-input-text" name="hm-location-dropdown" id="hm-location-dropdown" onChange={saveLocation} required>
                                <option value="">Select Location</option>
                                /*North Campus*/
                                <optgroup label="North Campus">
                                    <option value="Alfiero Center">Alfiero Center</option>
                                    <option value="Alumni Arena">Alumni Arena</option>
                                    <option value="Baird Hall">Baird Hall</option>
                                    <option value="Baird Research Park">Baird Research Park</option>
                                    <option value="Baker Chilled Water Plant">Baker Chilled Water Plant</option>
                                    <option value="Baldy Hall">Baldy Hall</option>
                                    <option value="Beane Service Center">Beane Service Center</option>
                                    <option value="Bell Hall">Bell Hall</option>
                                    <option value="Bissell Hall">Bissell Hall</option>
                                    <option value="Bonner Hall">Bonner Hall</option>
                                    <option value="Bookstore">Bookstore</option>
                                    <option value="Campus Mail Center">Campus Mail Center</option>
                                    <option value="Capen Hall">Capen Hall</option>
                                    <option value="Center for the Arts">Center for the Arts</option>
                                    <option value="Center for Tomorrow">Center for Tomorrow</option>
                                    <option value="Child Care Center">Child Care Center</option>
                                    <option value="Clemens Hall">Clemens Hall</option>
                                    <option value="Commons">Commons</option>
                                    <option value="Computing Center">Computing Center</option>
                                    <option value="Cooke Hall">Cooke Hall</option>
                                    <option value="Creekside Village">Creekside Village</option>
                                    <option value="Crofts Hall">Crofts Hall</option>
                                    <option value="Davis Hall">Davis Hall</option>
                                    <option value="Ellicott Complex">Ellicott Complex</option>
                                    <option value="Flickinger Court">Flickinger Court</option>
                                    <option value="Flint Village">Flint Village</option>
                                    <option value="Fronczak Hall">Fronczak Hall</option>
                                    <option value="Furnas Hall">Furnas Hall</option>
                                    <option value="Governors Residence Halls">Governors Residence Halls</option>
                                    <option value="Lehman Hall">Lehman Hall</option>
                                    <option value="Clinton Hall">Clinton Hall</option>
                                    <option value="Dewey Hall">Dewey Hall</option>
                                    <option value="Roosevelt Hall">Roosevelt Hall</option>
                                    <option value="Greiner Hall">Greiner Hall</option>
                                    <option value="GRoW Home">GRoW Home</option>
                                    <option value="Hadley Village">Hadley Village</option>
                                    <option value="Helm Warehouse">Helm Warehouse</option>
                                    <option value="HRD Building">HRD Building</option>
                                    <option value="Hochstetter Hall">Hochstetter Hall</option>
                                    <option value="Jacobs Management Center">Jacobs Management Center</option>
                                    <option value="Jarvis Hall">Jarvis Hall</option>
                                    <option value="Ketter Hall">Ketter Hall</option>
                                    <option value="Knox Lecture Hall">Knox Lecture Hall</option>
                                    <option value="Lockwood Library">Lockwood Library</option>
                                    <option value="Mathematics Building">Mathematics Building</option>
                                    <option value="Morris Sports Performance Center">Morris Sports Performance Center</option>
                                    <option value="Murchie Family Fieldhouse">Murchie Family Fieldhouse</option>
                                    <option value="Natural Sciences Complex">Natural Sciences Complex</option>
                                    <option value="Norton Hall">Norton Hall</option>
                                    <option value="O’Brian Hall">O’Brian Hall</option>
                                    <option value="Park Hall">Park Hall</option>
                                    <option value="Slee Hall">Slee Hall</option>
                                    <option value="South Lake Village">South Lake Village</option>
                                    <option value="Stadium">Stadium</option>
                                    <option value="Statler Food Commissary">Statler Food Commissary</option>
                                    <option value="Student Union">Student Union</option>
                                    <option value="Talbert Hall">Talbert Hall</option>
                                    <option value="Visitor Information Booth">Visitor Information Booth</option>
                                    <option value="Ellicott Complex">Ellicott Complex</option>
                                    <option value="Fargo Quadrangle">Fargo Quadrangle</option>
                                    <option value="Evans Quadrangle">Evans Quadrangle</option>
                                    <option value="Red Jacket Quadrangle">Red Jacket Quadrangle</option>
                                    <option value="Richmond Quadrangle">Richmond Quadrangle</option>
                                    <option value="Spaulding Quadrangle">Spaulding Quadrangle</option>
                                    <option value="Wilkeson Quadrangle">Wilkeson Quadrangle</option>
                                    <option value="Academic Center">Academic Center</option>
                                    <option value="Katharine Cornell Theatre">Katharine Cornell Theatre</option>
                                    <option value="Albert P. Sy Lecture Hall">Albert P. Sy Lecture Hall</option>
                                    <option value="C3 Crossroads Culinary Center3">C3 Crossroads Culinary Center</option>
                                </optgroup>
                                /*South Campus*/
                                <optgroup label="South Campus">
                                    <option value="Abbott Hall">Abbott Hall</option>
                                    <option value="Acheson Annex">Acheson Annex</option>
                                    <option value="Beck Hall">Beck Hall</option>
                                    <option value="Biomedical Education Building">Biomedical Education Building</option>
                                    <option value="Biomedical Research Building">Biomedical Research Building</option>
                                    <option value="Cary Hall">Cary Hall</option>
                                    <option value="Child Care Center">Child Care Center</option>
                                    <option value="Clark Hall">Clark Hall</option>
                                    <option value="Clement Hall">Clement Hall</option>
                                    <option value="Crosby Hall">Crosby Hall</option>
                                    <option value="Diefendorf Hall">Diefendorf Hall</option>
                                    <option value="Farber Annex">Farber Annex</option>
                                    <option value="Farber Hall">Farber Hall</option>
                                    <option value="Foster Hall">Foster Hall</option>
                                    <option value="Goodyear Hall">Goodyear Hall</option>
                                    <option value="Harriman Hall">Harriman Hall</option>
                                    <option value="Hayes A">Hayes A</option>
                                    <option value="NFTA University Station">NFTA University Station</option>
                                    <option value="Parker Hall">Parker Hall</option>
                                    <option value="Pharmacy Building">Pharmacy Building</option>
                                    <option value="Service Building (220 Winspear)">Service Building (220 Winspear)</option>
                                    <option value="Service Center (250 Winspear)">Service Center (250 Winspear)</option>
                                    <option value="Service Garage Building">Service Garage Building</option>
                                    <option value="Sherman Annex">Sherman Annex</option>
                                    <option value="Sherman Hall">Sherman Hall</option>
                                    <option value="Squire Hall">Squire Hall</option>
                                    <option value="Townsend Hall">Townsend Hall</option>
                                    <option value="Wende Hall">Wende Hall</option>
                                    <option value="Hayes B<">Hayes B</option>
                                    <option value="Hayes C">Hayes C</option>
                                    <option value="Hayes D">Hayes D</option>
                                    <option value="Hayes Hall">Hayes Hall</option>
                                    <option value="Howe Research Building">Howe Research Building</option>
                                    <option value="Kimball Tower">Kimball Tower</option>
                                    <option value="Mackay Heating Plant">Mackay Heating Plant</option>
                                    <option value="Michael Hall">Michael Hall</option>
                                </optgroup>
                            </select>
                            <label id="location-error" className="post-form-error"></label>
                        </div>
                        <div className = "rg-input-wrapper">
                            <label htmlFor="hm-start-date" className="form-input-label">Start Date <span style={{color:'#e63946'}}>*</span></label>
                            <input type="date" name="hm-first-date" id="hm-first-date" className="rg-input-text" onChange={saveFirst} required></input>
                            <label id="start-date-error" className="post-form-error"></label>
                        </div>
                        <div className = "rg-input-wrapper">
                            <label htmlFor="hm-end-date" className="form-input-label">End Date <span style={{color:'#e63946'}}>*</span></label>
                            <input type="date" name="hm-end-date" id="hm-end-date" className="rg-input-text" onChange={saveLast} required></input>
                            <label id="end-date-error" className="post-form-error"></label>
                        </div>

                        <div className = "rg-input-wrapper">
                            <label htmlFor="hm-start-time" className="form-input-label">Start Time <span style={{color:'#e63946'}}>*</span></label>
                            <input type="time" name="hm-start-time" id="hm-start-time" className="rg-input-text" onChange={saveStart} required></input>
                            <label id="start-time-error" className="post-form-error"></label>
                        </div>

                        <div className = "rg-input-wrapper">
                            <label htmlFor="hm-end-time" className="form-input-label">End Time <span style={{color:'#e63946'}}>*</span></label>
                            <input type="time" name="hm-end-time" id="hm-end-time" className="rg-input-text" onChange={saveEnd} required></input>
                            <label id="end-time-error" className="post-form-error"></label>
                        </div>

                        <div className = "rg-input-wrapper">
                            <label htmlFor="hm-privacy" className="form-input-label">Privacy <span style={{color:'#e63946'}}>*</span></label>
                            <select name="hm-public-dropdown" id="hm-public-dropdown" className="rg-input-text" onChange={savePrivate} required>
                                <option value="">Select Privacy</option>
                                <option value="Public">Public</option>
                                <option value="Private">Private</option>
                            </select>
                            <label id="privacy-error" className="post-form-error"></label>
                        </div>

                    </div>

                    <div className = "post-box-footer">
                        {post_error && (
                            <button type="submit" className = "post-button-error" >Create Post</button>
                        )}
                        {!post_error && (
                            <button type="submit" className = "reset-button" >Create Post</button>
                        )}
                    </div>
                </div>
            {/* </div> */}
        </form>
    )
}
export default CreatePost
